
import React from 'react';
import Select from 'react-select';

class DropdownSelect extends React.Component {
    state = {
            selectedOption: '',
            selectedId: 0
    };
    handleChange = selectedOption => {
        this.setState({
            selectedOption,
            selectedId: this.props.options.indexOf(selectedOption) //saving the index of the selection
        });
        this.props.handleChange(selectedOption);
    };
    customStyles = {
        menu: (provided, state) => ({
            ...provided,
            width: '100%'
        }),
        control: (base, state) => ({
            ...base,
            border: 0,
            boxShadow: 0,
            '&:hover': {
                border: 0
            }
        }),
        singleValue: (provided, state) => {
            const fontSize = '16px';
            return { ...provided, fontSize };
        }
    };
    render() {
        const { options } = this.props;
        return (
            <Select
                placeholder='Hospital'
                value={options[this.state.selectedId]} //we need to access the value this way to get the focus back to the dropdown selection.
                onChange={this.handleChange}
                options={options}
                styles={this.customStyles}
            />
        );
    }
}
export default DropdownSelect;


// WEBPACK FOOTER //
// ./src/components/DropdownSelect.js